import { i18n } from '@lingui/core'
import { Trans } from '@lingui/macro'

export const canadaProvincesData = /** @type {const} */ ([
  {
    label: <Trans>Alberta</Trans>,
    labelString: i18n._('Alberta'),
    value: 'Alberta'
  },
  {
    label: <Trans>British Columbia</Trans>,
    labelString: i18n._('British Columbia'),
    value: 'British Columbia'
  },
  {
    label: <Trans>Manitoba</Trans>,
    labelString: i18n._('Manitoba'),
    value: 'Manitoba'
  },
  {
    label: <Trans>New Brunswick</Trans>,
    labelString: i18n._('New Brunswick'),
    value: 'New Brunswick'
  },
  {
    label: <Trans>Newfoundland and Labrador</Trans>,
    labelString: i18n._('Newfoundland and Labrador'),
    value: 'Newfoundland and Labrador'
  },
  {
    label: <Trans>Northwest Territories</Trans>,
    labelString: i18n._('Northwest Territories'),
    value: 'Northwest Territories'
  },
  {
    label: <Trans>Nova Scotia</Trans>,
    labelString: i18n._('Nova Scotia'),
    value: 'Nova Scotia'
  },
  {
    label: <Trans>Nunavut</Trans>,
    labelString: i18n._('Nunavut'),
    value: 'Nunavut'
  },
  {
    label: <Trans>Ontario</Trans>,
    labelString: i18n._('Ontario'),
    value: 'Ontario'
  },
  {
    label: <Trans>Prince Edward Island</Trans>,
    labelString: i18n._('Prince Edward Island'),
    value: 'Prince Edward Island'
  },
  {
    label: <Trans>Québec</Trans>,
    labelString: i18n._('Québec'),
    value: 'Québec'
  },
  {
    label: <Trans>Saskatchewan</Trans>,
    labelString: i18n._('Saskatchewan'),
    value: 'Saskatchewan'
  },
  {
    label: <Trans>Yukon</Trans>,
    labelString: i18n._('Yukon'),
    value: 'Yukon'
  }
])
